import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListInfosasComponent } from './list-prestation/list-prestation.component';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { PrestationModalAjoutComponent } from './modal/prestation-modal-ajout/prestation-modal-ajout.component';
import { PrestationFormComponent } from './prestation-form/prestation-form.component';
import { DetailInfosasComponent } from './detail-prestation/detail-prestation.component';
import { PrestationModalChooseIntervenantComponent } from './modal/prestation-modal-choose-intervenant/prestation-modal-choose-intervenant.component';
import { ActivitePrestationFormComponent } from './activitePrestation/activitePrestation-form/activitePrestation-form.component';
import { ActivitePrestationModalAjoutComponent } from './activitePrestation/activitePrestation-modal-ajout/activitePrestation-modal-ajout.component';
import { PrestationModalDetailActivitePrestationComponent } from './modal/prestation-modal-detail-activitePrestation/prestation-modal-detail-activitePrestation.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgxEditorModule } from 'ngx-editor';
import { NavPrestationModule } from '../nav-prestation/nav-prestation.module';

@NgModule({
	declarations: [
		PrestationFormComponent,
		DetailInfosasComponent,
		ListInfosasComponent,
		PrestationModalAjoutComponent,
		PrestationModalDetailActivitePrestationComponent,
		ActivitePrestationFormComponent,
		ActivitePrestationModalAjoutComponent,
		PrestationModalChooseIntervenantComponent
	],
	imports: [SharedModule, NgxSliderModule, NgxEditorModule, NavPrestationModule],
	providers: [DateUtils]
})
export class InfosasModule {}
